module.exports = __webpack_public_path__ + "20acc37f27893bb3fb268490f182138b.png";